<section class="bg-[#F5F5F5] py-10 lg:py-20 space-y-5 px-3 md:px-5 2xl:px-28 3xl:px-52">
  <h3 class="font-semibold text-2xl md:text-3xl lg:text-4xl text-center">
    Browse by Models
  </h3>
  <div class="container mx-auto flex xl:hidden overflow-x-auto gap-2 py-1.5">
    <article class="shrink-0 w-[45%]" *ngFor="let model of models">
      <a [routerLink]="model.link">
        <div
          class="bg-white group hover:bg-black transition-all duration-300 shadow-md rounded-lg p-2 text-center"
        >
          <img [src]="model.image" alt="" />
          <p
            class="font-semibold transition-all duration-300 group-hover:text-white"
          >
            {{ model.model }}
          </p>
        </div>
      </a>
    </article>
  </div>

  <div class="mx-auto container hidden xl:flex overflow-x-auto gap-2 lg:gap-4 py-1">
    <article class="shrink-0 w-[40%] lg:w-1/5" *ngFor="let model of models">
      <a [routerLink]="model.link">
        <div
          class="bg-white group hover:bg-black transition-all duration-300 shadow-md rounded-lg p-2 text-center"
        >
          <img [src]="model.image" alt="" />
          <p
            class="font-semibold transition-all duration-300 group-hover:text-white"
          >
            {{ model.model }}
          </p>
        </div>
      </a>
    </article>
  </div>
</section>
